import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import style from './index.less';

const MessageSpeechToTxt = props => {
  const { speechToTxtData } = props;
  return speechToTxtData.fail ? null : (
    <div className={style.translate_wrap}>
      <Divider className={style.translate_divider} />
      {speechToTxtData.speeching ? <LoadingOutlined className={style.translate_icon} /> : null}
      {speechToTxtData.text}
    </div>
  );
};

export default MessageSpeechToTxt;
